import { type ComponentProps } from "react";

const IdeaIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 16C4.45 16 3.97917 15.8042 3.5875 15.4125C3.19583 15.0208 3 14.55 3 14V12.75C2.05 12.1 1.3125 11.2667 0.7875 10.25C0.2625 9.23333 0 8.15 0 7C0 5.05 0.679167 3.39583 2.0375 2.0375C3.39583 0.679167 5.05 0 7 0C8.95 0 10.6042 0.679167 11.9625 2.0375C13.3208 3.39583 14 5.05 14 7C14 8.15 13.7375 9.22917 13.2125 10.2375C12.6875 11.2458 11.95 12.0833 11 12.75V14C11 14.55 10.8042 15.0208 10.4125 15.4125C10.0208 15.8042 9.55 16 9 16H5ZM5 20C4.71667 20 4.47917 19.9042 4.2875 19.7125C4.09583 19.5208 4 19.2833 4 19V18H10V19C10 19.2833 9.90417 19.5208 9.7125 19.7125C9.52083 19.9042 9.28333 20 9 20H5Z"
        fill="currentColor"
      />
    </svg>
  );
};

IdeaIcon.displayName = "IdeaIcon";

export default IdeaIcon;
